import { render, staticRenderFns } from "./SchoolContractForm.vue?vue&type=template&id=1553af91&"
import script from "./SchoolContractForm.vue?vue&type=script&lang=js&"
export * from "./SchoolContractForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SchoolContractForm.vue?vue&type=custom&index=0&blockType=styles&scoped=true&lang=scss"
if (typeof block0 === 'function') block0(component)

export default component.exports